<template>
  <div class="animated fadeIn">
  <b-breadcrumb><strong>Order Listing</strong></b-breadcrumb>
    
  <b-row >
       
    <!----- SideBar All Design List ---->
     <!-- <sidebarSettingsComponent></sidebarSettingsComponent> -->
    <!----- SideBar All Design List End ----> 

     <div class="design-container-details__main">
      <div class="col-md-12 ">


            <!-- code for table -->
              <b-row>
                
                <b-col md="12">
                  <b-card-body>
                  <div class="row mt-4"> 
                  </div>  
              <b-row class="col-md-12 ">
                <input type="hidden" name="isactiveId" id="isactiveId" value="">
                <input type="hidden" name="brand_title" id="brand_title" value="">
                  <b-col md="4" class="my-1">
                    <b-form-group label-cols-sm="3" label="Filter" class="mb-0">
                      <b-input-group>
                        <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                        <b-input-group-append>
                          <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col md="4" class="my-1">
                    <b-form-group label-cols-sm="3" label="Sort" class="mb-0">
                      <b-input-group>
                        <b-form-select v-model="sortBy" :options="sortOptions">
                          <option slot="first" :value="null">-- none --</option>
                        </b-form-select>
                        <b-form-select v-model="sortDesc" :disabled="!sortBy" slot="append">
                          <option :value="false">Asc</option> <option :value="true">Desc</option>
                        </b-form-select>
                      </b-input-group>
                    </b-form-group>
                  </b-col>             
                 <!--  <b-col md="4" class="my-1">
                    <b-form-group label-cols-sm="3" label="Per page" class="mb-0">
                      <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                    </b-form-group>
                  </b-col>   -->          
              </b-row> 
                <b-col sm="12" class="text-right">
               <p > <b>Total Records :<span style="color:red;">{{ this.totalRows }}</span></b> </p>
              </b-col> 
                  <div class="col-md-12">
                    <b-table class="mt-4" show-empty stacked="md" :busy="isBusy"  :items="items"  :fields="fields1"  :current-page="currentPage" :perPage="perPage":bordered="bordered"    :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"    @filtered="onFiltered" >
                  
                    <div slot="table-busy" class="text-center text-danger my-2">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong>Loading...</strong>
                    </div>

                    <template slot="user_type" slot-scope="row">
                      <span  @click="toggleInfoModal(row.item)" >
                      <span data-toggle="tooltip" title="User Type" v-if="row.item.user_type =='0'" > 
                        <span class="badge badge-danger">Admin</span>
                      </span>  

                      <span data-toggle="tooltip" title="User Type" v-if="row.item.user_type =='1'" > 
                        <span class="badge badge-primary">Brand Manager</span>
                      </span>  
                      <span data-toggle="tooltip" title="User Type" v-if="row.item.user_type =='2'"  >
                        <span class="badge badge-success">Brand User</span>
                      </span>
                      <span data-toggle="tooltip" title="User Type" v-if="row.item.user_type =='3'"  >
                        <span class="badge badge-success">Designer</span>
                      </span>
                      <span data-toggle="tooltip" title="User Type" v-if="row.item.user_type =='4'"  >
                        <span class="badge badge-success">Fit Technician</span>
                      </span>
                      <span data-toggle="tooltip" title="User Type" v-if="row.item.user_type =='5'"  >
                        <span class="badge badge-success">Design Head</span>
                      </span>
                      <span data-toggle="tooltip" title="User Type" v-if="row.item.user_type =='6'"  >
                        <span class="badge badge-success">Quality Controll</span>
                      </span>
                      </span>
                    </template>


                    <template slot="actions" slot-scope="row">
                      <i @click="editinfoModal(row.item)"  data-toggle="tooltip" title="Update Vendor Details" class="fa fa-pencil-square-o" aria-hidden="true" style=" color: green;">&nbsp;&nbsp;&nbsp;&nbsp;
                        <!-- <i class="fa fa-edit"></i> -->
                      </i>
                      <i  v-on:click="deleteinfoModal(row.item)"  data-toggle="tooltip" title="Delete Vendor Details"  class="fa fa-trash" aria-hidden="true" style="color: red">
                         <!-- <i class="fa fa-trash" aria-hidden="true" style="color: red"></i> -->
                      </i>

                    </template>    
                    <template slot="action" slot-scope="row">
                      <button type="button" class="btn btn-info" style="width: 110px;" @click="opendesignModal(row.item)">Info</button>
                    </template>        
                  </b-table>
                      <b-col md="6" class="my-1">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  class="my-0"
                ></b-pagination>
              </b-col>      
            <!-- Info modal -->         
                 </div>

                  </b-card-body>
               </b-col>
            </b-row>          
             <!-- code for table ends -->

             <!-- Code For Design Details Model -->
      <b-modal title="Design Details" v-model="showdesigndetails" @ok="showdesigndetails = false">
      <b-row>
    
      <b-col sm="12" class='col-md-12'>
        
        <b-form name="addSegmentForm" @submit.prevent="addNewSegment('addSegmentForm','1')" >

                 <div  class='col-md-12' >    

                
                  <b-form-group>
                    <b-col md="5" class="pull-left">
                     <label for="name"><b>Brand Title</b></label>
                   </b-col> 
                   <b-col md="1" class="pull-left"><b>:</b></b-col>
                    
                   <b-col md="6" class="pull-right" >{{customer.brand_title}}
                   </b-col>
                  </b-form-group>

                  <b-form-group>
                    <b-col md="5" class="pull-left">
                     <label for="name"><b>Segment Title</b></label>
                   </b-col> 
                   <b-col md="1" class="pull-left"><b>:</b></b-col>
                    
                   <b-col md="6" class="pull-right" >{{customer.segment_title}}
                   </b-col>
                  </b-form-group>

                  <b-form-group>
                    <b-col md="5" class="pull-left">
                     <label for="name"><b>Collection Title</b></label>
                   </b-col> 
                   <b-col md="1" class="pull-left"><b>:</b></b-col>
                    
                   <b-col md="6" class="pull-right" >{{customer.collection_title}}
                   </b-col>
                  </b-form-group>

                  <b-form-group>
                    <b-col md="5" class="pull-left">
                     <label for="name"><b>Style Name</b></label>
                   </b-col> 
                   <b-col md="1" class="pull-left"><b>:</b></b-col>
                    
                   <b-col md="6" class="pull-right" >{{customer.style_name}}
                   </b-col>
                  </b-form-group>

            

                </div>          

              <!-- </div> -->
            
            <div slot="footer"  style="margin-top:20px;text-align:right">
            
              <button type="button" class="btn btn-success">Accept</button>&nbsp;&nbsp;
             <button type="button" class="btn btn-danger">Reject</button>

            </div>
         </b-form>
      </b-col>

    </b-row>
    </b-modal>
             <!-- Code For Design Details Ends -->

 
      </div>
    </div>     
      
  </b-row>    





    
  </div>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import auth from '@/utils/auth'
import Vue from 'vue'



import sidebarSettingsComponent from './_sidebarSettingsComponent.vue'

const axios = require('axios')
export default {
  name: 'Tabs',
 components: {
    sidebarSettingsComponent
  },  
  data () {
    return {
      isBusy: false,  
      sampelAddModal: false,    
      customer: {},
      addAgentMaster : false,
      editAgentMaster:false,
      bordered: true,
      showSideMenu:true,
      items:[],
      result:[],
      value:[],
      sortDesc: true,
      sortDirection: 'desc',
      fields1: [
          { key: 'brand_title', label: 'Brand Title', sortable: true, sortDirection: 'desc' },
          { key: 'segment_title', label: 'Segment Title', sortable: true},
           { key: 'collection_title', label: 'Collection Title', sortable: true},
            { key: 'style_name', label: 'Style Name' ,tdClass: 'nameOfTheClass'},
          { key: 'action', label: 'Action' ,tdClass: 'nameOfTheClass'},
         
      
       ],
       
       showdesigndetails: false,
       currentPage: 1,
       perPage:  10,
       sortBy: null,
       sortDesc: true,
       sortDirection: 'desc',
       filter: null,
       totalRows: 0,
   }

  },
  created: function() { 
  
  this.getdesignheadstyledetails(); 
   
  },
 computed: {
      sortOptions() {
        // Create an options list from our fields
        return this.fields1
          .filter(f => f.sortable)
          .map(f => {
            return { text: f.label, value: f.key }
          })
      }
    },

  
  methods: 
  {   
    onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length
        this.currentPage = 1
      },


      opendesignModal(value) {
        this.customer.brand_title = value.brand_title;
        this.customer.segment_title = value.segment_title;
        this.customer.collection_title = value.collection_title;
        this.customer.style_name = value.style_name;
        this.showdesigndetails =true;

 },

    getdesignheadstyledetails: function(value) 
    {


      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
     
      this.login_user_id = userInfo[0].user_id;

     const Obj = {
               user_id : this.login_user_id
              // user_id : 25
            }

        this.isBusy = true;      
        axios.post(`${CONSTANTS.API_URL}/getdesignheadstyledetails`,Obj)
        .then(response => {
          
          this.result = response.data

          if (this.result.returnmsg === 'Successful') {
            this.items  = this.result.returnvalue;
            this.totalRows = this.result.returnvalue.length;
            this.isBusy = !this.isBusy;
            
          }else {
           this.collection_list =[];
           this.totalRows=0;
             this.isBusy = !this.isBusy;
          }


        })
        .catch(e => {
          this.errors.push(e)
        })

    },

  }
}
</script>
<style>
.account-settings__content>* {
    flex-grow: 1;
}

.profile-settings {
    flex-grow: 1;
    padding: 20px 24px;
}

.profile-settings>h1 {
    font-weight: 600;
    padding: 0;
    margin: 0;
}
.profile-settings .content {
    display: flex;
}
.profile-settings .content .profile-fields-container {
    max-width: 356px;
    margin-right: 56px;
}
.profile-settings .tabular-fields {
    font-size: 14px;
    line-height: 20px;
    flex-direction: column;
}
.profile-settings .tabular-fields .field-row {
    margin-top: 20px;
    min-height: 44px;
    display: flex;
    flex-direction: row;
    align-items: center;
}
.profile-settings .tabular-fields .field-row>.field-label {
    color: var(--fill-grey-medium);
    min-width: 100px;
    margin: 12px 0;
}
.profile-settings .tabular-fields .field-row>.field-value {
    margin-left: 32px;
    flex-grow: 1;
}

.design-container-details__main{
 
  background-color:white;
  border-left:1px solid #d4d4d4;

}

.profile-settings .content .img.img-invalid {
    background-color: #6f4ce6;
}
.profile-settings .content .img {
    max-width: 100%;
    position: relative;
    height: 175px;
    width: 175px;
    border-radius: 4px;
    overflow: hidden;
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: contain;
    border: 1px solid var(--fill-grey-light2);
    padding: 5px;
}


</style>


